// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jhCu","textarea":"styles_textarea__WR4C1"};